import { Model, attr, belongsTo } from '@elatonsev/js-models';
import PhotoModel from './PhotoModel';
import NearestTimeModel from './NearestTimeModel';

export default class ResourceModel extends Model {
  name = attr('string');
  specialization = attr('string');
  photo = belongsTo(PhotoModel);
  nearest_time = belongsTo(NearestTimeModel);
}